<template>
    <v-dialog v-model="show" width="500">
        <v-card class="rounded-lg">
            <v-card-item class="pb-1">
                <v-card-title class="d-flex">
                    <h4>{{ dialogStore.title }}</h4>
                </v-card-title>
            </v-card-item>
            <v-card-text class="pb-2">
                <p class="text-caption text-medium-emphasis" v-html="dialogStore.message"></p>
            </v-card-text>
            <v-card-actions class="pb-6 pr-6">
                <div class="d-flex flex-row justify-end flex-gap-2">
                    <ButtonComponent
                        v-for="(action, index) in dialogStore.actions"
                        :key="index"
                        :disabled="isPerformingAction && isPerformingAction !== action.text"
                        :loading="isPerformingAction === action.text"
                        :variant="action.variant"
                        :color="action.color"
                        :prepend-icon="action.icon"
                        @click="handleAction(action)"
                    >
                        {{ action.text }}
                    </ButtonComponent>
                </div>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useDialogStore } from '@/stores/dialog';
import ButtonComponent from '@/components/utils/buttons/ButtonComponent.vue';

const dialogStore = useDialogStore();
const isPerformingAction = ref(false);

const show = computed({
    get: () => dialogStore.show,
    set: (value) => {
        if (value === false) {
            dialogStore.clear();
        }
        dialogStore.show = value;
    },
});

const handleAction = async (action) => {
    if (action.handler) {
        isPerformingAction.value = action.text;
        await action.handler().catch(console.error);
        isPerformingAction.value = false;
    }
    dialogStore.clear();
};
</script>

<style scoped></style>
